export default __webpack_public_path__ + "static/media/twitter.6c3a6b9a.svg";